import { withConfig } from '@/router/navigationGuards';
import { RouteRecordRaw } from 'vue-router';

export const CHAT_ROUTE_NAME = 'ChatView';
export const CHAT_ROUTE_PATH = '/chat';

export const chatRoute: RouteRecordRaw = {
  name: CHAT_ROUTE_NAME,
  path: CHAT_ROUTE_PATH,
  component: () => import('@/modules/AgenticChat/views/IndexView.vue'),
  beforeEnter: [withConfig],
  meta: {
    titleLocalizationKey: 'SKILLS.chat',
  },
};
